import { AnalyzeActionTypes, AnalyzeActions } from '@appStore/analyze/actions/analyze.actions';
import { AnalyzePaneSettings, AnalyzePeriodData, MeteringPointsFilterData } from '@model';
import { AnalyzeSettingsType, MeteringType, DatePeriodType, AnalyzeCompareWith } from '@enums';
import { TemperatureMeteringPoint } from 'app/models/temperature-metering-point.model';

export interface State {
  paneSettings: AnalyzePaneSettings[];
  periodsData: AnalyzePeriodData[];
  selectedAnalyzeSettingsType: AnalyzeSettingsType;
  selectedAnalyzeSettingsMeteringType: MeteringType;
  temperatureMeteringPoints: TemperatureMeteringPoint[];
  key: string;
  keyLoaded: boolean;
  keyLoading: boolean;
  resetPeriod: boolean;
  resetGraphValues: boolean;
  dataLoadFailed: boolean;
}

export const initialState: State = {
  paneSettings: [
    AnalyzePaneSettings.initalState(MeteringType.Hot, AnalyzeSettingsType.Energy),
    AnalyzePaneSettings.initalState(MeteringType.Hot, AnalyzeSettingsType.Flow),
    AnalyzePaneSettings.initalState(MeteringType.Hot, AnalyzeSettingsType.Temp),
    AnalyzePaneSettings.initalState(MeteringType.Hot, AnalyzeSettingsType.Effect),
    AnalyzePaneSettings.initalState(MeteringType.Hot, AnalyzeSettingsType.Economy),
    AnalyzePaneSettings.initalState(MeteringType.Cold, AnalyzeSettingsType.Energy),
    AnalyzePaneSettings.initalState(MeteringType.Cold, AnalyzeSettingsType.Flow),
    AnalyzePaneSettings.initalState(MeteringType.Cold, AnalyzeSettingsType.Temp),
    AnalyzePaneSettings.initalState(MeteringType.Cold, AnalyzeSettingsType.Effect),
    AnalyzePaneSettings.initalState(MeteringType.Cold, AnalyzeSettingsType.Economy),
    AnalyzePaneSettings.initalState(MeteringType.HotLogical, AnalyzeSettingsType.Energy),
    AnalyzePaneSettings.initalState(MeteringType.HotLogical, AnalyzeSettingsType.Flow),
    AnalyzePaneSettings.initalState(MeteringType.HotLogical, AnalyzeSettingsType.Temp),
    AnalyzePaneSettings.initalState(MeteringType.HotLogical, AnalyzeSettingsType.Effect),
    AnalyzePaneSettings.initalState(MeteringType.HotLogical, AnalyzeSettingsType.Economy),
    AnalyzePaneSettings.initalState(MeteringType.ColdLogical, AnalyzeSettingsType.Energy),
    AnalyzePaneSettings.initalState(MeteringType.ColdLogical, AnalyzeSettingsType.Flow),
    AnalyzePaneSettings.initalState(MeteringType.ColdLogical, AnalyzeSettingsType.Temp),
    AnalyzePaneSettings.initalState(MeteringType.ColdLogical, AnalyzeSettingsType.Effect),
    AnalyzePaneSettings.initalState(MeteringType.ColdLogical, AnalyzeSettingsType.Economy)
  ],
  periodsData: [
    // HOT
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Energy, MeteringType.Hot),
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Flow, MeteringType.Hot),
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Temp, MeteringType.Hot),
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Effect, MeteringType.Hot),
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Economy, MeteringType.Hot),

    AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Energy, MeteringType.Hot),
    AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Flow, MeteringType.Hot),
    AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Temp, MeteringType.Hot),
    AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Effect, MeteringType.Hot),

    AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Energy, MeteringType.Hot),
    AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Flow, MeteringType.Hot),
    AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Temp, MeteringType.Hot),
    AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Effect, MeteringType.Hot),

    // COLD
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Energy, MeteringType.Cold),
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Flow, MeteringType.Cold),
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Temp, MeteringType.Cold),
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Effect, MeteringType.Cold),
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Economy, MeteringType.Cold),

    AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Energy, MeteringType.Cold),
    AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Flow, MeteringType.Cold),
    AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Temp, MeteringType.Cold),
    AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Effect, MeteringType.Cold),

    AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Energy, MeteringType.Cold),
    AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Flow, MeteringType.Cold),
    AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Temp, MeteringType.Cold),
    AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Effect, MeteringType.Cold),

    // HOT LOGICAL
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Energy, MeteringType.HotLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Flow, MeteringType.HotLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Temp, MeteringType.HotLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Effect, MeteringType.HotLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Economy, MeteringType.HotLogical),

    AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Energy, MeteringType.HotLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Flow, MeteringType.HotLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Temp, MeteringType.HotLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Effect, MeteringType.HotLogical),

    AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Energy, MeteringType.HotLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Flow, MeteringType.HotLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Temp, MeteringType.HotLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Effect, MeteringType.HotLogical),

    // COLD LOGICAL
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Energy, MeteringType.ColdLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Flow, MeteringType.ColdLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Temp, MeteringType.ColdLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Effect, MeteringType.ColdLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Economy, MeteringType.ColdLogical),

    AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Energy, MeteringType.ColdLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Flow, MeteringType.ColdLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Temp, MeteringType.ColdLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Effect, MeteringType.ColdLogical),

    AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Energy, MeteringType.ColdLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Flow, MeteringType.ColdLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Temp, MeteringType.ColdLogical),
    AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Effect, MeteringType.ColdLogical)
  ],
  selectedAnalyzeSettingsType: AnalyzeSettingsType.Energy,
  selectedAnalyzeSettingsMeteringType: MeteringType.Hot,
  temperatureMeteringPoints: [],
  keyLoaded: false,
  keyLoading: false,
  resetPeriod: false,
  resetGraphValues: false,
  key: null,
  dataLoadFailed:false
};

const setMpIdsOnType = (
  state: State,
  meteringPointFilterData: MeteringPointsFilterData,
  meteringType: MeteringType
) => {
  let allOldSet = [...state.paneSettings.filter(x => x.meteringType === meteringType)];
  let allNewToSet = <AnalyzePaneSettings[]>allOldSet.map(x => ({
    ...x,
    masterMeteringPointId: meteringPointFilterData.masterMeteringPointId,
    meteringPointIds: meteringPointFilterData.meteringPointIds,
    explicitMeteringPointId:
      meteringPointFilterData.meteringPointIds && meteringPointFilterData.meteringPointIds.length > 0
        ? meteringPointFilterData.meteringPointIds[0]
        : null
  }));

  return {
    ...state,
    paneSettings: [...state.paneSettings.filter(x => !(x.meteringType === meteringType)), ...allNewToSet]
  };
};

const resetDataOnType = (
  state: State,
  meteringPointFilterData: MeteringPointsFilterData,
  meteringType: MeteringType
) => {
  let allSettings = [...state.paneSettings.filter(x => x.meteringType === meteringType)];
  let allNewSettings = <AnalyzePaneSettings[]>allSettings.map(
    x =>
      ({
        ...x,
        masterMeteringPointId: meteringPointFilterData.masterMeteringPointId,
        meteringPointIds: meteringPointFilterData.meteringPointIds,
        explicitMeteringPointId:
          meteringPointFilterData.meteringPointIds && meteringPointFilterData.meteringPointIds.length > 0
            ? meteringPointFilterData.meteringPointIds[0]
            : null
      } as AnalyzePaneSettings)
  );
  if (!meteringPointFilterData.meteringPointIds) {
    allNewSettings = state.paneSettings.filter(x => x.meteringType === meteringType);
  }
  return {
    ...state,
    paneSettings: [...state.paneSettings.filter(x => !(x.meteringType === meteringType)), ...allNewSettings],
    periodsData: [
      ...state.periodsData.filter(x => x.meteringType !== meteringType),
      AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Energy, meteringType),
      AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Flow, meteringType),
      AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Temp, meteringType),
      AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Effect, meteringType),
      AnalyzePeriodData.initalState(DatePeriodType.Month, AnalyzeSettingsType.Economy, meteringType),

      AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Energy, meteringType),
      AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Flow, meteringType),
      AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Temp, meteringType),
      AnalyzePeriodData.initalState(DatePeriodType.Day, AnalyzeSettingsType.Effect, meteringType),

      AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Energy, meteringType),
      AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Flow, meteringType),
      AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Temp, meteringType),
      AnalyzePeriodData.initalState(DatePeriodType.Hour, AnalyzeSettingsType.Effect, meteringType)
    ],
    dataLoadFailed:false
  };
};

export function reducer(state = initialState, action: AnalyzeActions): State {
  let compareYears: number[] = [];
  let currentPaneSettings: AnalyzePaneSettings;

  switch (action.type) {
    case AnalyzeActionTypes.AnalyzeLoadConsumptionData:
      return {
        ...state,
        paneSettings: [
          ...state.paneSettings.filter(
            x =>
              !(
                x.meteringType === action.payload.paneSettings.meteringType &&
                x.settingsType === action.payload.paneSettings.settingsType
              )
          ),
          {
            ...action.payload.paneSettings,
            monthDateFrom:
              action.payload.period === DatePeriodType.Month
                ? action.payload.dateFrom
                : action.payload.paneSettings.monthDateFrom,
            monthDateTo:
              action.payload.period === DatePeriodType.Month
                ? action.payload.dateTo
                : action.payload.paneSettings.monthDateTo,

            dayDateFrom:
              action.payload.period === DatePeriodType.Day
                ? action.payload.dateFrom
                : action.payload.paneSettings.dayDateFrom,
            dayDateTo:
              action.payload.period === DatePeriodType.Day
                ? action.payload.dateTo
                : action.payload.paneSettings.dayDateTo,

            hourDateFrom:
              action.payload.period === DatePeriodType.Hour
                ? action.payload.dateFrom
                : action.payload.paneSettings.hourDateFrom,
            hourDateTo:
              action.payload.period === DatePeriodType.Hour
                ? action.payload.dateTo
                : action.payload.paneSettings.hourDateTo
          }
        ],
        periodsData: [
          ...state.periodsData.filter(
            x =>
              !(
                x.settingsType === action.payload.paneSettings.settingsType &&
                x.meteringType === action.payload.paneSettings.meteringType &&
                x.period === action.payload.period
              )
          ),
          {
            ...state.periodsData.find(
              x =>
                x.settingsType === action.payload.paneSettings.settingsType &&
                x.meteringType === action.payload.paneSettings.meteringType &&
                x.period === action.payload.period
            ),
            consumptionData: [],
            consumptionDataLoaded: false,
            consumptionDataLoading: true
          }
        ],
        resetPeriod: false,
        resetGraphValues: false,
        dataLoadFailed:false,
        selectedAnalyzeSettingsMeteringType : action.payload.paneSettings.meteringType,
        selectedAnalyzeSettingsType: action.payload.paneSettings.settingsType
      };
    case AnalyzeActionTypes.AnalyzeLoadConsumptionSuccess:
      if (action.payload.paneSettings.compareYears && action.payload.paneSettings.compareYears.length > 0) {
        compareYears = [action.payload.dateFrom.getFullYear(), ...action.payload.paneSettings.compareYears];
      }
      currentPaneSettings = state.paneSettings.find(
        x =>
          x.meteringType === action.payload.paneSettings.meteringType &&
          x.settingsType === action.payload.paneSettings.settingsType
      );
      return {
        ...state,
        paneSettings: [
          ...state.paneSettings.filter(
            x =>
              !(
                x.meteringType === action.payload.paneSettings.meteringType &&
                x.settingsType === action.payload.paneSettings.settingsType
              )
          ),
          {
            ...currentPaneSettings,
            monthDateFrom:
              action.payload.period === DatePeriodType.Month
                ? action.payload.dateFrom
                : currentPaneSettings.monthDateFrom,
            monthDateTo:
              action.payload.period === DatePeriodType.Month ? action.payload.dateTo : currentPaneSettings.monthDateTo,

            dayDateFrom:
              action.payload.period === DatePeriodType.Day ? action.payload.dateFrom : currentPaneSettings.dayDateFrom,
            dayDateTo:
              action.payload.period === DatePeriodType.Day ? action.payload.dateTo : currentPaneSettings.dayDateTo,

            hourDateFrom:
              action.payload.period === DatePeriodType.Hour
                ? action.payload.dateFrom
                : currentPaneSettings.hourDateFrom,
            hourDateTo:
              action.payload.period === DatePeriodType.Hour ? action.payload.dateTo : currentPaneSettings.hourDateTo
          }
        ],
        periodsData: [
          ...state.periodsData.filter(
            x =>
              !(
                x.settingsType === action.payload.paneSettings.settingsType &&
                x.meteringType === action.payload.paneSettings.meteringType &&
                x.period === action.payload.period
              )
          ),
          {
            ...state.periodsData.find(
              x =>
                x.settingsType === action.payload.paneSettings.settingsType &&
                x.meteringType === action.payload.paneSettings.meteringType &&
                x.period === action.payload.period
            ),
            consumptionData: action.payload.consumptionData,
            consumptionDataLoaded: true,
            consumptionDataLoading: false,
            consumptionDataCompareYears: compareYears,
            dateFrom: action.payload.dateFrom,
            dateTo: action.payload.dateTo,
            timeStamp: +new Date()
          }
        ],
        resetPeriod: false,
        resetGraphValues: false,
        dataLoadFailed:false
      };
    case AnalyzeActionTypes.AnalyzeLoadConsumptionFail:
      return { ...state, dataLoadFailed:true };

    case AnalyzeActionTypes.AnalyzeLoadEconomyPrognosisSuccess:
      return {
        ...state,
        periodsData: [
          ...state.periodsData.filter(
            x =>
              !(
                x.settingsType === action.payload.paneSettings.settingsType &&
                x.meteringType === action.payload.paneSettings.meteringType &&
                x.period === action.payload.period
              )
          ),
          {
            ...state.periodsData.find(
              x =>
                x.settingsType === action.payload.paneSettings.settingsType &&
                x.meteringType === action.payload.paneSettings.meteringType &&
                x.period === action.payload.period
            ),
            prognosisData: action.payload.consumptionData,
            prognosisDataLoaded: true,
            prognosisDataLoading: false,
            dateFrom: action.payload.dateFrom,
            dateTo: action.payload.dateTo,
            timeStamp: +new Date()
          }
        ],
        resetPeriod: false,
        resetGraphValues: false,
        dataLoadFailed:false
      };

    case AnalyzeActionTypes.AnalyzeLoadEconomyPrognosisFail:
      return { ...state, dataLoadFailed:true };

    case AnalyzeActionTypes.AnalyzeLoadMeterReadingData:
      return {
        ...state,
        paneSettings: [
          ...state.paneSettings.filter(
            x =>
              !(
                x.meteringType === action.payload.paneSettings.meteringType &&
                x.settingsType === action.payload.paneSettings.settingsType
              )
          ),
          {
            ...action.payload.paneSettings
          }
        ],
        periodsData: [
          ...state.periodsData.filter(
            x =>
              !(
                x.settingsType === action.payload.paneSettings.settingsType &&
                x.meteringType === action.payload.paneSettings.meteringType &&
                x.period === action.payload.period
              )
          ),
          {
            ...state.periodsData.find(
              x =>
                x.settingsType === action.payload.paneSettings.settingsType &&
                x.meteringType === action.payload.paneSettings.meteringType &&
                x.period === action.payload.period
            ),
            meterReadingDataLoading: true,
            meterReadingType: action.payload.compareWith
          }
        ],
        resetPeriod: false,
        resetGraphValues: false,
        dataLoadFailed:false
      };
    case AnalyzeActionTypes.AnalyzeLoadMeterReadingSuccess:
      if (action.payload.paneSettings.compareYears && action.payload.paneSettings.compareYears.length > 0) {
        compareYears = [action.payload.dateFrom.getFullYear(), ...action.payload.paneSettings.compareYears];
      }
      currentPaneSettings = state.paneSettings.find(
        x =>
          x.meteringType === action.payload.paneSettings.meteringType &&
          x.settingsType === action.payload.paneSettings.settingsType
      );
      return {
        ...state,
        paneSettings: [
          ...state.paneSettings.filter(
            x =>
              !(
                x.meteringType === action.payload.paneSettings.meteringType &&
                x.settingsType === action.payload.paneSettings.settingsType
              )
          ),
          {
            ...currentPaneSettings,
            monthDateFrom:
              action.payload.period === DatePeriodType.Month
                ? action.payload.dateFrom
                : currentPaneSettings.monthDateFrom,
            monthDateTo:
              action.payload.period === DatePeriodType.Month ? action.payload.dateTo : currentPaneSettings.monthDateTo,

            dayDateFrom:
              action.payload.period === DatePeriodType.Day ? action.payload.dateFrom : currentPaneSettings.dayDateFrom,
            dayDateTo:
              action.payload.period === DatePeriodType.Day ? action.payload.dateTo : currentPaneSettings.dayDateTo,

            hourDateFrom:
              action.payload.period === DatePeriodType.Hour
                ? action.payload.dateFrom
                : currentPaneSettings.hourDateFrom,
            hourDateTo:
              action.payload.period === DatePeriodType.Hour ? action.payload.dateTo : currentPaneSettings.hourDateTo
          }
        ],
        periodsData: [
          ...state.periodsData.filter(
            x =>
              !(
                x.settingsType === action.payload.paneSettings.settingsType &&
                x.meteringType === action.payload.paneSettings.meteringType &&
                x.period === action.payload.period
              )
          ),
          {
            ...state.periodsData.find(
              x =>
                x.settingsType === action.payload.paneSettings.settingsType &&
                x.meteringType === action.payload.paneSettings.meteringType &&
                x.period === action.payload.period
            ),
            meterReadingData: action.payload.meterReadingData,
            meterReadingDataLoaded: true,
            meterReadingDataLoading: false,
            meterReadingType: action.payload.paneSettings.compareWith,
            dateFrom: action.payload.dateFrom,
            dateTo: action.payload.dateTo,
            timeStamp: +new Date()
          }
        ],
        resetPeriod: false,
        resetGraphValues: false,
        dataLoadFailed:false
      };
    case AnalyzeActionTypes.AnalyzeLoadMeterReadingFail:
      return { ...state,dataLoadFailed:true };
    case AnalyzeActionTypes.AnalyzeUpdateSettings:
      return {
        ...state,
        paneSettings: [
          ...state.paneSettings.filter(
            x => !(x.meteringType === action.payload.meteringType && x.settingsType === action.payload.settingsType)
          ),
          action.payload
        ],
        selectedAnalyzeSettingsMeteringType: action.payload.meteringType,
        selectedAnalyzeSettingsType: action.payload.settingsType,
        resetPeriod: false,
        resetGraphValues: false,
        dataLoadFailed:false
      };
      case AnalyzeActionTypes.AnalyzeUpdatePaneSettings:
        return {
          ...state,
          paneSettings: [
            ...state.paneSettings.filter(
              x => !(x.meteringType === action.payload.meteringType && x.settingsType === action.payload.settingsType)
            ),
            action.payload
          ]
        };
    case AnalyzeActionTypes.AnalyzeUpdatePeriodData:
      return {
        ...state,
        periodsData: [
          ...state.periodsData.filter(
            x =>
              !(
                x.settingsType === action.payload.settingsType &&
                x.meteringType === action.payload.meteringType &&
                x.period === action.payload.period
              )
          ),
          action.payload
        ],
        resetPeriod: false,
        resetGraphValues: false,
        dataLoadFailed:false
      };
    case AnalyzeActionTypes.AnalyzeResetPeriodPositions:
      return {
        ...state,
        periodsData: [
          ...state.periodsData.map(x => ({
            ...x,
            sliderStart: 0,
            sliderStop: 0
          }))
        ],
        resetPeriod: true,
        resetGraphValues: false,
        dataLoadFailed:false
      };
    case AnalyzeActionTypes.AnalyzeResetPeriodPositionItem:
      return {
        ...state,
        periodsData: [
          ...state.periodsData.map(x =>
            x.settingsType === action.payload.settingsType &&
            x.meteringType === action.payload.meteringType &&
            x.period === action.payload.period
              ? {
                  ...x,
                  sliderStart: 0,
                  sliderStop: 0
                }
              : x
          )
        ],
        resetPeriod: true,
        resetGraphValues: false,
        dataLoadFailed:false
      };

    case AnalyzeActionTypes.AnalyzeResetDataOnType:
      return {
        ...state,
        paneSettings: [
          ...state.paneSettings.filter(
            x => !(x.settingsType === action.payload.settingsType && x.meteringType === action.payload.meteringType)
          ),
          action.payload
        ],
        periodsData: [
          ...state.periodsData.filter(
            x => !(x.settingsType === action.payload.settingsType && x.meteringType === action.payload.meteringType)
          ),
          {
            ...state.periodsData.find(
              x =>
                x.settingsType === action.payload.settingsType &&
                x.meteringType === action.payload.meteringType &&
                x.period === DatePeriodType.Month
            ),
            consumptionData: [],
            consumptionDataLoaded: false,
            consumptionDataLoading: false,
            consumptionDataCompareYears: [],
            meterReadingData: [],
            meterReadingDataLoaded: false,
            meterReadingDataLoading: false,
            meterReadingType: AnalyzeCompareWith.Nothing,
            timeStamp: 0
          },
          {
            ...state.periodsData.find(
              x =>
                x.settingsType === action.payload.settingsType &&
                x.meteringType === action.payload.meteringType &&
                x.period === DatePeriodType.Day
            ),
            consumptionData: [],
            consumptionDataLoaded: false,
            consumptionDataLoading: false,
            consumptionDataCompareYears: [],
            meterReadingData: [],
            meterReadingDataLoaded: false,
            meterReadingDataLoading: false,
            meterReadingType: AnalyzeCompareWith.Nothing,
            timeStamp: 0
          },
          {
            ...state.periodsData.find(
              x =>
                x.settingsType === action.payload.settingsType &&
                x.meteringType === action.payload.meteringType &&
                x.period === DatePeriodType.Hour
            ),
            consumptionData: [],
            consumptionDataLoaded: false,
            consumptionDataLoading: false,
            consumptionDataCompareYears: [],
            meterReadingData: [],
            meterReadingDataLoaded: false,
            meterReadingDataLoading: false,
            meterReadingType: AnalyzeCompareWith.Nothing,
            timeStamp: 0
          }
        ],
        resetPeriod: false,
        resetGraphValues: false,
        dataLoadFailed:false
      };
    case AnalyzeActionTypes.AnalyzeResetColdData:
      return resetDataOnType(state, action.payload, MeteringType.Cold);
    case AnalyzeActionTypes.AnalyzeResetHeatData:
      return resetDataOnType(state, action.payload, MeteringType.Hot);
    case AnalyzeActionTypes.AnalyzeResetColdLogicalData:
      return resetDataOnType(state, action.payload, MeteringType.ColdLogical);
    case AnalyzeActionTypes.AnalyzeResetHeatLogicalData:
      return resetDataOnType(state, action.payload, MeteringType.HotLogical);
    case AnalyzeActionTypes.AnalyzeResetGraphValues:
      return {
        ...state,
        resetGraphValues: true,
        dataLoadFailed:false
      };
    case AnalyzeActionTypes.AnalyzeSetMeteringPointsOnHeatData:
      return setMpIdsOnType(state, action.payload, MeteringType.Hot);
    case AnalyzeActionTypes.AnalyzeSetMeteringPointsOnColdData:
      return setMpIdsOnType(state, action.payload, MeteringType.Cold);
    case AnalyzeActionTypes.AnalyzeSetMeteringPointsOnHeatLogicalData:
      return setMpIdsOnType(state, action.payload, MeteringType.HotLogical);
    case AnalyzeActionTypes.AnalyzeSetMeteringPointsOnColdLogicalData:
      return setMpIdsOnType(state, action.payload, MeteringType.ColdLogical);

    case AnalyzeActionTypes.AnalyzeLoadTemperatureData:
      return { ...state };
    case AnalyzeActionTypes.AnalyzeLoadTemperatureDataSuccess:
      return { ...state, temperatureMeteringPoints: action.payload };
    case AnalyzeActionTypes.AnalyzeLoadTemperatureDataFail:
      return { ...state };

    case AnalyzeActionTypes.CreateReportKey:
      return { ...state, keyLoaded: false, keyLoading: true, key: null };
    case AnalyzeActionTypes.CreateReportKeyFail:
      return { ...state, keyLoaded: false, keyLoading: false };
    case AnalyzeActionTypes.CreateReportKeySuccess:
      return { ...state, keyLoaded: true, keyLoading: false, key: action.payload };

    case AnalyzeActionTypes.AnalyzeClearData:
      return {
        ...initialState
      };
    case AnalyzeActionTypes.AnalyzeMeteringTabChanged:
      return { ...state, selectedAnalyzeSettingsMeteringType: action.payload };

    case AnalyzeActionTypes.AnalyzeTabChanged:
      return { ...state, selectedAnalyzeSettingsType: action.payload };
  }
  return state;
}

export const getAnalyzeSettings = (state: State) => state.paneSettings;
export const getAnalyzePeriodData = (state: State) => state.periodsData;
export const getSelectedAnalyzeSettingsType = (state: State) => state.selectedAnalyzeSettingsType;
export const getSelectedAnalyzeSettingsMeteringType = (state: State) => state.selectedAnalyzeSettingsMeteringType;
export const getTemperatureMeteringPoints = (state: State) => state.temperatureMeteringPoints;
export const getReportKey = (state: State) => state.key;
export const getResetPeriod = (state: State) => state.resetPeriod;
export const getResetGraph = (state: State) => state.resetGraphValues;
export const getDataLoadFailed = (state: State) => state.dataLoadFailed;
